import { Component } from '@angular/core';
import { ModalController, Loading, ToastController, LoadingController, AlertController, NavController } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TaskDetailPage } from './../../pages/task-detail/task-detail';
import { TaskUpdatePage } from './../../pages/task-update/task-update';
import { SessionDetailPage } from './../../pages/session-detail/session-detail';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import moment from 'moment';
//import { of } from 'rxjs/observable/of';

interface myInterface {
  dob: number;
  calendar: [{
    complete: boolean;
    date: Date;
    fileReq: boolean;
    files: [{
      fullPath: string;
      name: string;
      path: string;
    }];
    notes: string;
    task: boolean;
    topic: string;
  }];
  company: string;
  name: string;
  ocupation: string;
  sex: string;
}

interface myInterface2 {
  id: string;
  complete: boolean;
  creationDate: Date;
  description: string;
  dueDate: Date;
  files: any[];
  idAlumno: string;
  idCoach: string;
  idSesion: string;
  title: string;
}

interface myInterface3 {
  id: string;
  creationDate: Date;
  description: string;
  files: any[];
  idAlumno: string;
  idCoach: string;
  title: string;
  sessionDate: Date;
  tasks: string[];
}
@Component({
  selector: 'tasks-user',
  templateUrl: 'tasks-user.html'
})
export class TasksUserComponent {

  itemsCollection: AngularFirestoreCollection<myInterface>;
  items: myInterface[];
  tasksCollection: AngularFirestoreCollection<myInterface>;
  tasks: myInterface2[];
  sessionsCollection: AngularFirestoreCollection<myInterface3>;
  sessions: myInterface3[];
  currentUser: any;
  myForm: FormGroup;
  loading: Loading;
  selectedFiles1: FileList;
  file1;
  Files: boolean = false;
  arrayFiles: any[] = [];
  arrayResult: any[] = [];
  idParent: string;
  nameParent: string;
  inputFile: any[] = [""];
  tareas: any[] = [];

  tareasSinSesion: myInterface2[];

  constructor(public navCtrl: NavController, public formBuilder: FormBuilder, public asf: AngularFirestore, public modalCtrl: ModalController, public afAuth: AngularFireAuth, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
    this.myForm = this.formBuilder.group({
      description: ['', Validators.required],
      dueDate: [''],
      idSesion: ['', Validators.required],
      title: ['', Validators.required]
    });
  }

  loadTasks() {
    this.presentLoadingCustom();
    if (this.afAuth.auth.currentUser.uid) {
      let promise1 = this.initTable(this.afAuth.auth.currentUser.uid);
      let promise2 = this.noSessionsTasks(this.afAuth.auth.currentUser.uid);
      Promise.all([promise1, promise2]).then(values => {
        this.tareas = values[0];
        this.tareasSinSesion = values[1];
        this.loading.dismiss();
      }).catch(error => {
        ////console.error(error);
        this.loading.dismiss();
      });
    }
  }

  ngOnInit() {
    if (this.afAuth.auth.currentUser.uid) {
      this.tasksCollection = this.asf.collection("Tasks", ref => ref.where("idAlumno", "==", this.afAuth.auth.currentUser.uid));
      this.tasksCollection.snapshotChanges().subscribe(() => {
        this.loadTasks();
      });
    }
  }

  async initTable(uuid: string): Promise<any[]> {
    let arrayRet: any[] = [];
    if (uuid) {
      await this.asf.collection("Sessions").ref.where("idAlumno", "==", uuid).orderBy("sessionDate", "desc").get().then(async sessionsArray => {
        if (!sessionsArray.empty) {
          for (let i = 0; i < sessionsArray.docs.length; i++) {
            let data = sessionsArray.docs[i].data();
            data['type'] = 1;
            const id = sessionsArray.docs[i].id;
            arrayRet.push({ id, ...data });
            await this.asf.collection("Tasks").ref.where("idSesion", "==", id).get().then(taskArray => {
              if (!taskArray.empty) {
                taskArray.forEach(element => {
                  const data = element.data();
                  const id = element.id;
                  arrayRet.push({ id, ...data });
                });
              }
            }).catch(error => {
              ////console.error(error);
              return [];
            });
          }
        }
      }).catch(error => {
        ////console.error(error);
        return [];
      });
    }
    return arrayRet;
  }


  async noSessionsTasks(uuid: string): Promise<any[]> {
    let arrayRet: any[] = [];
    if (uuid) {
      await this.asf.collection("Tasks").ref.where("idAlumno", "==", uuid).where("idSesion", "==", "sinsesion").get().then(tasksArray => {
        if (!tasksArray.empty) {
          arrayRet = tasksArray.docs.map(ele => {
            const data = ele.data();
            const id = ele.id;
            return { id, ...data };
          });
        }
      }).catch(error => {
        ////console.error(error);
        return [];
      });
    }
    return arrayRet;
  }

  deleteFromArray(index: number) {
    this.arrayFiles.splice(index, 1);
  }

  addStorage() {
    this.presentLoadingCustom();
    if (this.arrayFiles.length > 0) {
      this.uploadFileSStorage(this.arrayFiles).then(data => {
        this.arrayResult = data;
        this.addUserToDb();
      });
    } else {
      this.addUserToDb();
    }
  }

  addUserToDb() {
    let data = {
      complete: false,
      creationDate: new Date(),
      description: this.myForm.value.description,
      dueDate: this.myForm.value.dueDate ? new Date(this.myForm.value.dueDate) : '',
      files: this.arrayResult,
      idAlumno: this.currentUser.id,
      idCoach: this.afAuth.auth.currentUser.uid,
      idSesion: this.myForm.value.idSesion,
      title: this.myForm.value.title
    }
    ////console.log(data);
    this.asf.collection('Tasks').add(data).then(res => {
      let arregloTareas: any[];
      let newId = res.id;
      this.asf.doc("Sessions/" + data.idSesion).ref.get().then(datos => {
        if (datos.exists) {
          arregloTareas = datos.exists && datos.data() && datos.data().tasks ? datos.data().tasks : [];
          arregloTareas.push(newId);
          this.asf.doc("Sessions/" + data.idSesion).update({ tasks: arregloTareas }).then(error => {
            this.myForm.reset();
            this.loading.dismiss();
            this.arrayFiles = [];
            this.presentToast("Tarea agregada correctamente");
          }).catch(error => {
            this.loading.dismiss();
            this.presentToast(error);
          });
        } else {
          this.myForm.reset();
          this.loading.dismiss();
          this.arrayFiles = [];
          this.presentToast("Tarea agregada correctamente");
        }
      });
    }).catch(error => {
      this.loading.dismiss();
      this.presentToast(error);
    });
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  async uploadFileSStorage(files: any[]): Promise<any[]> {
    let filesRet: any[] = [];
    for (let x: number = 0; x < files.length; x++) {
      var storageRef = firebase.storage().ref();
      var fileRef = storageRef.child('files/' + new Date().getTime() + files[x].file.name);
      await fileRef.put(files[x].file).then((res) => {
        filesRet.push({ "downloadURL": res.downloadURL, "fullPath": res.metadata.fullPath, "name": files[x].file.name });
      });
    }
    return filesRet;
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  finalizar(event: any, id: string) {
    this.asf.doc("Tasks/" + id).update({ "complete": event.checked }).then(() => {
      ////console.log("Listo");
    }).catch(error => {
      ////console.log(error);
    });
  }

  presentConfirmDelete(id: string, idSesion: string) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar tarea',
      message: '¿Estas seguro de eliminar tarea?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteItem(id, idSesion);
          }
        }
      ]
    });
    alert.present();
  }

  deleteItem(idDocument: string, idSesion: string) {
    this.presentLoadingCustom();
    this.asf.doc("Tasks/" + idDocument).delete().then(() => {

      let arregloTareas: any[];

      ////console.log(idSesion);
      this.asf.doc("Sessions/" + idSesion).ref.get().then(document => {
        arregloTareas = document.data() && document.data().tasks ? document.data().tasks : [];

        let index = arregloTareas.indexOf(idDocument);

        if (index > -1) {
          arregloTareas.splice(index, 1);
          this.asf.doc("Sessions/" + idSesion).update({ tasks: arregloTareas }).then(() => {
            this.presentToast('Eliminado correctamente');
            this.loading.dismiss();
          }).catch(error => {
            ////console.log(error);
            this.loading.dismiss();
            this.presentToast('¡Ha ocurrido un error!');
          });

        } else {
          this.presentToast('Ha ocurrido un error');
          this.loading.dismiss();
        }

      });

    }).catch(error => {
      ////console.log(error);
      this.loading.dismiss();
      this.presentToast('¡Ha ocurrido un error!');
    });
  }

  updateItem(item: any) {
    let Modal = this.modalCtrl.create(TaskUpdatePage, { "item": item });
    Modal.present();
  }

  viewItem(item: any) {
    let Modal = this.modalCtrl.create(TaskDetailPage, { "item": item });
    Modal.present();
  }

  stringDate(date: any): string {
    if (date == '') {
      return "Sin fecha asignada"
    } else {
      moment.locale("es");
      return moment(date).format("lll");
    }
  }

  viewItem2(item: any) {
    let Modal = this.modalCtrl.create(SessionDetailPage, { "item": item });
    Modal.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/tasks-user/tasks-user.ts